import React, { FC, ReactElement } from 'react'
import { ReactComponent as FileIcon } from '../../assets/icons/file.svg'
import { ReactComponent as FolderIcon } from '../../assets/icons/folder2.svg'
import { ReactComponent as ProcessExamIcon } from '../../assets/icons/process-exam.svg'
import BreadCrumbs, { BreadCrumb } from '../../components/breadCrumbs'
import H2 from '../../components/h2'
import TabBar from '../../components/tabBar'
import LoggedArea from '../loggedArea'
import { TabContainer, TabHeader } from './style'

type TabItem = {
  name: string
  icon: ReactElement
}

type TabItemsProps = {
  activeItem: number
  title: string | ReactElement
  subtitle: string | ReactElement
  info?: string
  items?: TabItem[]
  onChangeTab?: (itemIndex: number) => void
  navigationComponent?: ReactElement
  breadcrumbs?: BreadCrumb[]
}

const TabItems: FC<TabItemsProps> = ({
  onChangeTab,
  title,
  subtitle,
  info,
  children,
  activeItem,
  items,
  navigationComponent,
  breadcrumbs
}): ReactElement => {
  return (
    <LoggedArea navigationComponent={navigationComponent}>
      <TabHeader>
        {breadcrumbs && <BreadCrumbs breadcrumbs={breadcrumbs} />}
        <H2>{title}</H2>
        <p>{subtitle}</p>
        {info && (
          <p className='info'>{info}</p>
        )}
      </TabHeader>
      <TabBar
        onClick={onChangeTab}
        activeIndex={activeItem}
        items={items || [
          { name: 'Inserir Exame', icon: <ProcessExamIcon /> },
          { name: 'Digitar Exame', icon: <FolderIcon /> },
          { name: 'Solicitar novo laboratório', icon: <FileIcon /> }
        ]}
      />
      <TabContainer>
        {children}
      </TabContainer>
    </LoggedArea>
  )
}

export default TabItems
